// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const focus: Styleguide["focus"] = {
    color: "#115ffb", // Store Custom Code
};

export default focus;
